import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb = () => {
    const location = useLocation();
    const pathnames = location.pathname.split('/').filter(x => x);

    // Capitalize first letter of the breadcrumb text
    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const handleBackClick = () => {
        if (pathnames.includes('edit')) {
            const previousPath = pathnames.slice(0, pathnames.length - 2).join('/');
            return `/${previousPath}`;
        }
        return '/'; 
    };

    return (
        <div className='container pt-3 pb-1'>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    {pathnames.map((value, index) => {
                        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
                        const label = capitalizeFirstLetter(value);

                        // Check if we're on the "edit" page and want to show "Back"
                        if ( index === pathnames.length - 2 && location.pathname.includes('edit')) {
                            return (
                                <li key={index} className="breadcrumb-item">
                                    Edit
                                </li>
                            );
                        }
                        if ( index === pathnames.length - 1) {
                            return '';
                        }

                        return (
                            <li key={index} className="breadcrumb-item">
                                {index === pathnames.length - 1 ? (
                                    label // Last item is not a link
                                ) : (
                                    <Link to={to}>{label}</Link>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </nav>
        </div>
    );
};

export default Breadcrumb;
